/**
 * Google Search on the 3.8 bots (pipecat/shared/google_search.py): Gemini answers
 * some searches without citing a page (prod 0a062b81: 3 of 5). Their log row has
 * a null result and the test call gets `{}`, so the card showed only the query,
 * or `{}`. It says so instead.
 */

export const GOOGLE_SEARCH_TOOL = "google_search";
export const NO_SOURCES_TEXT = "Searched, no sources returned";

/** True for a Google Search that came back with no page to cite. */
export function isSearchWithoutSources(toolName: string | null | undefined, result: unknown): boolean {
  if (toolName !== GOOGLE_SEARCH_TOOL) return false;
  return result === null || result === undefined || (typeof result === "object" && Object.keys(result).length === 0);
}
